﻿import { CaptureSnapshot } from "./capture-snapshot";
import { OptionalRedirect } from "./optional-redirect";
import { RequestAssistance } from "./request-assistance";

export default function StorylineActions(props: any) {
    return <>
        <CaptureSnapshot />
        <RequestAssistance />
        <OptionalRedirect />
    </>;
}